import { render, staticRenderFns } from "./checkBlockTextValue.vue?vue&type=template&id=3f83c824&scoped=true&"
import script from "./checkBlockTextValue.vue?vue&type=script&lang=js&"
export * from "./checkBlockTextValue.vue?vue&type=script&lang=js&"
import style0 from "./checkBlockTextValue.vue?vue&type=style&index=0&id=3f83c824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83c824",
  null
  
)

export default component.exports